import Filter from './Filter';
import { CHANGE_EVENT, INPUT_EVENT } from './constants';

export default class RegionFilter extends Filter {
    constructor({
        elm,
        displayDropdownCallback,
        addToSelectedFilters,
        removeFromSelectedFilters,
        displayMobileMenuCallback,
    }) {
        super({
            elm: elm,
            filterDataAttr: 'data-region-filter',
            dropdownDataAttr: 'data-region-dropdown',
            displayDropdownCallback: displayDropdownCallback,
            displayMobileMenuCallback: displayMobileMenuCallback,
        });
        if (this.dropdown) {
            this.zipcodeInput = this.dropdown.querySelector('input[type=text]');
            this.rangeSlider = this.dropdown.querySelector('input[type=range]');
            this.rangeSliderLabel = this.dropdown.querySelector(
                '[data-region-slider-display]',
            );
            this.rangeSliderTextLabel = this.dropdown.querySelector(
                '[data-region-slider-text-display]',
            );
            this.rangeWrapper = this.dropdown.querySelector('.range-wrapper');
            this.removeFromSelectedFilters = removeFromSelectedFilters;
            this.addToSelectedFilters = addToSelectedFilters;

            const updateZipcode = this.updateZipcode.bind(this);
            // Region zipcode and slider
            this.zipcodeInput?.addEventListener(CHANGE_EVENT, updateZipcode);

            // update range label on input change
            this.rangeSlider?.addEventListener(
                INPUT_EVENT,
                this.setRangeSliderLabel.bind(this),
            );
            // update actual filter input onchange
            this.rangeSlider?.addEventListener(CHANGE_EVENT, updateZipcode);

            // on first load
            this.setRangeSliderLabel();
        }
    }

    setRangeSliderValue(value) {
        this.rangeSlider.value =
            this.rangeSlider.min < 1 ? this.rangeSlider.min : value;
    }

    focusInputField() {
        this.zipcodeInput.focus();
    }

    setZipcodeValue(value) {
        this.zipcodeInput.value = value;
    }

    updateZipcode(fetchQuery = true) {
        const zipcodeValue = this.zipcodeInput?.value;
        const radiusValue = this.rangeSlider?.value;
        const resetSlider = this.resetSlider.bind(this);
        this.removeFromSelectedFilters(this.zipcodeInput.name, resetSlider);
        this.setZipcodeValue(zipcodeValue);
        this.rangeSlider.value = !zipcodeValue
            ? this.rangeSlider.step
            : radiusValue;
        if (!zipcodeValue) {
            this.setDisabledSlider();
        } else {
            // create an inner span for special rendering of zipcode / range
            const customSpan = document.createElement('span');
            customSpan.innerText = this.zipcodeInput.value;
            const innerSpan = document.createElement('span');
            innerSpan.classList.add('text--bold');
            innerSpan.classList.add('text--italic');
            innerSpan.innerText = ` | Radius: ${this.rangeSlider.value} km`;
            customSpan.append(innerSpan);

            this.setDisabledSlider(false);
            this.setRangeSliderLabel();
            this.addToSelectedFilters(
                this.zipcodeInput,
                resetSlider,
                fetchQuery,
                customSpan,
            );
        }
    }

    setDisabledSlider(isDisabled = true) {
        this.rangeSlider.disabled = isDisabled;
        if (!isDisabled) {
            this.rangeSliderTextLabel.classList.add('active');
        } else {
            this.rangeSliderTextLabel.classList.remove('active');
        }
    }

    resetSlider() {
        this.rangeSlider.value = this.rangeSlider.step;
        this.setRangeSliderLabel();
        this.setDisabledSlider();
    }

    setRangeSliderLabel() {
        const min = this.rangeSlider.min;
        const val = this.rangeSlider.value;
        const max = this.rangeSlider.max;
        this.rangeSliderLabel.innerText = `${val}km.`;
        const newPosition = Number((val * 100) / (max - min));

        // Sorta magic numbers based on size of the native UI thumb
        this.rangeSliderLabel.style.left = `calc(${newPosition}% - (${
            newPosition * 0.05
        }px))`;
    }
}
